import * as React from 'react';

import {
    VerificationService,
    SuccessResponse,
    FormFooterComponent,
} from '@sheerid/jslib';

import { FormattedHTMLMessage } from 'react-intl';
import { LogoHeaderComponent } from '../../LogoHeaderComponent';


interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header">
                <LogoHeaderComponent/>
                <div className="sid-header__title sid-l-space-top-lg">
                <FormattedHTMLMessage
                    id="step.success.congradulations"
                    defaultMessage="Congratulations!" />
                </div>
                <p className="sid-header__subtitle">
                    <FormattedHTMLMessage
                        id="step.success.continue.verified"
                        defaultMessage="You've been verified. Below is your single-use coupon code that is ready for you to use right now. Your single-use coupon code can be used during checkout on <a href='https://www.vineyardvines.com' target='_blank'>www.vineyardvines.com</a>. The coupon code cannot be combined with any other offer or promotion." />
                </p>
            </div>

            <div className="sid-reward-code__header">
                <FormattedHTMLMessage
                    id="step.success.confirmationCode"
                    defaultMessage="Confirmation code:" />
            </div>

            <div className="sid-reward-code sid-l-space-top-md sid-h-jumbo-text">
                {(verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}'}
            </div>

            <div className="sid-submit sid-l-space-top-lg">
                <FormattedHTMLMessage
                        id="step.success.successLinkToStore"
                        defaultMessage="<a href='https://www.vineyardvines.com' target='_blank' class='sid-btn sid-btn--dark'> CONTINUE TO VINEYARD VINES </a>" />
            </div>


            <div className="sid-footer sid-l-space-top-md">
                <FormattedHTMLMessage
                    id="step.success.toMakeSure"
                    defaultMessage="To make sure you have every opportunity to use your discount, we’re also emailing you a copy of your code and a link to the Vineyard Vines website so that you can shop now, or shop later. Please check for an email from us (verify@sheerid.com) for all the details." />
            </div>

            <div className="sid-footer sid-l-space-top-md sid-h-small-text">
                <FormFooterComponent verificationService={verificationService} />
            </div>
        </div>
    );
};


export { StepSuccessComponent };
